/** Функци-хелперы для работы с текстом */

/**
 * Очистка html-строки от тегов
 * @param html string - html-строка
 * //todo: использовать эту функцию не напрямую, а через пайп
 */
export const stripHtml = (html: string) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
};

/**
 * Проверяет наличие символа в строке
 * @param target
 * @param character
 */
export const isCharacterInString = (target: string, character: string): boolean => {
    if (!target || !character || character.length !== 1) {
        return false;
    }
    const index = target.indexOf(character);
    return index !== -1;
};
